<template>
  <!-- <comcomponent v-bind:is="layout">
    <router-view v-bind:key="$route.fullPath"></router-view>
  </comcomponent> -->

  <div>
    <MainLayout v-if="this.$route.meta.layout==='MainLayout'"></MainLayout>
    <LoginLayout v-if="this.$route.meta.layout==='LoginLayout'"></LoginLayout>
    <LoginLayoutWide v-if="this.$route.meta.layout==='LoginLayoutWide'"></LoginLayoutWide>
    <ConsoleLayout v-if="this.$route.meta.layout==='ConsoleLayout'"></ConsoleLayout>
    <LoadingLayout v-if="this.$route.meta.layout==='LoadingLayout'"></LoadingLayout>
    <!-- <ExternalLayout v-if="this.$route.meta.layout==='ExternalLayout'"></ExternalLayout> -->
    <BlankLayout v-if="this.$route.meta.layout==='BlankLayout'"></BlankLayout>
    <SessionInvalidatedDialog></SessionInvalidatedDialog>
    <SubscriptionContactDialog v-model="subscriptionContactDialogVisible" />
  </div>


</template>

<script>

import MainLayout from './layouts2/mainLayout/MainLayout.vue'
import LoginLayout from './layouts2/loginLayout/LoginLayout.vue'
import LoginLayoutWide from './layouts2/loginLayout/LoginLayoutWide.vue'
import ConsoleLayout from './layouts2/consoleLayout/ConsoleLayout.vue'
import LoadingLayout from './layouts2/LoadingLayout.vue'
import BlankLayout from './layouts2/BlankLayout.vue'
import SessionInvalidatedDialog from './components/SessionInvalidatedDialog.vue'
import SubscriptionContactDialog from './components/dialogs/SubscriptionContactDialog.vue'
import { useMainStore } from './stores/MainStore.js'


export default {
  name: 'App',
  components: {
    MainLayout,
    LoginLayout,
    LoginLayoutWide,
    ConsoleLayout,
    LoadingLayout,
    // ExternalLayout,
    BlankLayout,
    SessionInvalidatedDialog,
    SubscriptionContactDialog,
  },
  computed: {
    subscriptionContactDialogVisible: {
      get() {
        const mainStore = useMainStore();
        return mainStore.subscriptionContactDialogVisible;
      },
      set(value) {
        const mainStore = useMainStore();
        if (value) {
          mainStore.showSubscriptionContactDialog();
        } else {
          mainStore.hideSubscriptionContactDialog();
        }
      },
    },
  },
  created: async function() {
    const storedAbilities = window.localStorage.getItem('abilities');
    if (storedAbilities) {
      const abilities = JSON.parse(storedAbilities);
      console.assert(Array.isArray(abilities), `Expected an array of abilities, got ${typeof abilities} instead.`);
      this.$ability.update(abilities);
    }

    const interfaceLanguage = window.localStorage.getItem('languageInterface');
    if (interfaceLanguage) {
      const language = interfaceLanguage || 'en';
      this.$i18n.locale = language;
    }
  },
}
</script>

<style>
</style>
